export class User {
    constructor(id: number, username: string, first_name: string, last_name: string) {
        this.id = id;
        this.username = username;
        this.first_name = first_name;
        this.last_name = last_name;
    }

    id: number;
    username: string;
    first_name: string;
    last_name: string;

}